import React, { useEffect, useState } from 'react'
import Route from 'tennders-transactions/views/Route'
import SelectRoute from 'tennders-market/offer/views/SelectRoute'
import HiddenMapView from 'tennders-transactions/components/HiddenMapView'
import DetailedLoadView from 'tennders-market/load/views/details/DetailedLoadView'
import DetailedTruckView from 'tennders-market/truck/views/details/DetailedTruckView'
import { isGoldLogistic } from 'tennders-common/constants/useConstants'
import LoadDetailsTable from 'tennders-market/load/views/details/LoadDetailsTable'
import TruckDetailsTable from 'tennders-market/truck/views/details/TruckDetailsTable'
import AssignView from 'tennders-transactions/views/assign/AssignView'
import TransactionSharedView from 'tennders-transactions/views/TransactionSharedView'
import DetailView from 'tennders-transactions/components/DetailView'
import useSession from 'tennders-auth/hooks/useSession'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useTransactionDetailStore from 'tennders-transactions/stores/useTransactionDetailStore'
import { StateType } from 'tennders-common/types/StateType'
import TransactionSharedInMarketPlaceView from 'tennders-transactions/views/TransactionSharedInMarketPlaceView'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const selectorAssignTruckLoadType = (state: StateType) => [state.assignTruckLoadType]
const selectorIsFixed = (state: StateType) => [state.assignTruckLoadType]
const SharedView = (transaction: TransactionType) => {
  if (transaction?.isCancelled) {
    return <DetailView transaction={transaction} isFixed />
  }
  if (transaction?.isMarketPlaced && transaction?.isSharedWith) {
    return <TransactionSharedView transaction={transaction} />
  }
  if (transaction?.isSharedWith && (transaction?.isMarketPlaced || transaction?.isSharedWithMarketPlace)) {
    return (
      <>
        <TransactionSharedInMarketPlaceView transaction={transaction} />
        <TransactionSharedView transaction={transaction} />
      </>
    )
  }
  if (transaction?.isSharedWithMarketPlace || transaction?.isMarketPlaced) {
    return <TransactionSharedInMarketPlaceView withDocs transaction={transaction} />
  }
  return <TransactionSharedView transaction={transaction} />
}
const TransactionContent = () => {
  const { isShipperUser, isCarrierUser } = useSession()
  const { transaction, closeTransaction } = useTransaction()
  const [assignTruckLoadType] = useTransactionDetailStore(selectorAssignTruckLoadType)
  const [isFixed] = useTransactionDetailStore(selectorIsFixed)
  const [showMap, setShowMap] = useState(!isShipperUser && !isCarrierUser)

  useEffect(() => () => setShowMap(false), [])

  return (
    <>
      <section className="tennders-big-slide-panel-right-left tennders-custom-scroll pl-0 pt-0">
        <Route />
        <div className="bg-color-light-gray b-r-10 px-20 py-10 mt-20">
          <div className="d-flex justify-space mb-16" onClick={() => setShowMap(prev => !prev)}>
            <h2 className="mb-0 pt-10">Map</h2>
            <FontAwesomeIcon
              icon={showMap ? faChevronUp : faChevronDown}
              className="cursor-pointer font-size-24 d-flex align-center"
            />
          </div>
          <div className="hr mt-0" />
          {transaction?.isOfferable && !transaction?.isMine && !transaction.matchedLoad && <SelectRoute />}
          <HiddenMapView showMap={showMap} />
        </div>
      </section>
      <section className="tennders-big-slide-panel-right-right tennders-custom-scroll bg-color-light-gray b-r-10">
        <div className="d-flex row mb-32">
          <DetailedLoadView
            transaction={transaction}
            load={transaction?.matchedLoad}
            close={closeTransaction}
          />
          <DetailedTruckView
            transaction={transaction}
            truck={transaction?.matchedTruck}
            close={closeTransaction}
          />
        </div>
        <div className="hr" />
        {isGoldLogistic && transaction?.matchedLoad?.shipments?.length > 0 && (
          <>
            <div className="d-flex row mb-32">
              <div className="w-50">
                {transaction?.matchedLoad?.shipments?.length > 0 && (
                  <LoadDetailsTable shipments={transaction?.matchedLoad?.shipments} />
                )}
              </div>
              <div className="w-50">
                {transaction?.matchedTruck && (
                  <TruckDetailsTable
                    allDetails={transaction?.matchedTruck?.allDetails}
                    truckPlate={transaction?.matchedTruck?.truckPlate}
                    trailerPlate={transaction?.matchedTruck?.trailerPlate}
                  />
                )}
              </div>
            </div>
            <div className="hr" />
          </>
        )}
        {assignTruckLoadType ? <AssignView /> : null}
        {assignTruckLoadType === null && (!transaction.matchedLoad || !transaction.matchedTruck) && (transaction.isSharedWith || transaction?.isShared || transaction?.isSharedWithMarketPlace)
          ? SharedView(transaction)
          : <DetailView transaction={transaction} isFixed={isFixed} />}
      </section>
    </>
  )
}
export default React.memo(TransactionContent)
